var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 114,
    viewBox: "0 0 220 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_239)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_417_239",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 220,
    height: 114
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.078 0H0V114H219.078V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_417_239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.498 12.8045C204.97 7.27279 197.627 4.2168 189.819 4.2168H29.2594C15.3061 4.2168 3.2081 14.1584 0.541125 27.8524L0.386518 28.5487V28.626C0.154607 30.2507 0 31.8754 0 33.5001V84.717C0 92.531 3.05349 99.8809 8.58069 105.451C14.1079 110.983 21.4517 114.039 29.2594 114.039H189.819C197.627 114.039 204.97 110.983 210.498 105.451C216.025 99.9195 219.078 92.5697 219.078 84.717V33.5001C219.078 25.6861 216.025 18.3362 210.498 12.8045ZM211.734 84.717C211.734 96.8249 201.917 106.65 189.819 106.65H29.2594C17.1614 106.65 7.34384 96.8249 7.34384 84.717V33.5001C7.34384 32.0688 7.49844 30.6376 7.76901 29.2836C9.74025 19.1873 18.6302 11.6053 29.2594 11.6053H189.819C201.917 11.6053 211.734 21.4309 211.734 33.5388V84.717Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.734 29.2835V80.4616C211.734 92.5695 201.917 102.395 189.819 102.395H29.2593C17.1613 102.395 7.34375 92.5695 7.34375 80.4616V29.2835C7.34375 27.8522 7.49836 26.4209 7.76892 25.067C9.74016 14.9706 18.6301 7.38867 29.2593 7.38867H189.819C201.917 7.38867 211.734 17.1756 211.734 29.2835Z",
    fill: "#FF6464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.498 8.58772C204.97 3.05599 197.627 0 189.819 0H29.2594C15.3061 0 3.2081 9.94164 0.541125 23.6356L0.42517 24.3705V24.4479C0.154607 26.0339 0 27.6586 0 29.2833V80.4615C0 88.2755 3.05349 95.6254 8.58069 101.196C14.1079 106.728 21.4517 109.784 29.2594 109.784H189.819C197.627 109.784 204.97 106.728 210.498 101.196C216.025 95.6641 219.078 88.3142 219.078 80.4615V29.2833C219.078 21.4693 216.025 14.1194 210.498 8.58772ZM211.734 80.5002C211.734 92.6081 201.917 102.434 189.819 102.434H29.2594C17.1614 102.434 7.34384 92.6081 7.34384 80.5002V29.2833C7.34384 27.8521 7.49844 26.4208 7.76901 25.0668C9.74025 14.9705 18.6302 7.38853 29.2594 7.38853H189.819C201.917 7.38853 211.734 17.2141 211.734 29.322V80.5002Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M19.5964 98.9137H196.196C196.196 98.9137 96.127 77.0962 66.3651 84.7169C37.0284 92.2215 47.4644 95.5482 19.5964 98.9137Z",
    fill: "#5E639B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M197.859 11.9141H21.2585C21.2585 11.9141 32.4289 33.7315 62.1908 26.1109C91.4888 18.6063 169.991 15.2795 197.859 11.9141Z",
    fill: "#5E639B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 93.8842C183.132 96.592 195.578 95.8184 198.129 94.0776C200.719 92.3369 204.043 84.4068 201.105 83.1689C199.752 82.5887 184.214 91.099 183.673 93.8842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.091 11.76C34.5548 9.4777 24.2734 10.5221 21.8383 11.6053C13.8761 15.1641 16.8523 19.8062 19.326 20.8506C20.4469 21.3148 33.6271 14.1197 34.091 11.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3932 24.6411C15.9631 22.4749 12.9483 21.5465 11.9433 22.4362C10.6292 23.5967 9.7015 31.2173 11.4795 31.0239C12.2912 30.9465 18.2822 25.9564 17.3932 24.6411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.08228 59.2241L4.87015 52.1837L7.38251 47.3096V53.2668L4.21307 55.8973L1.08228 59.2241Z",
    fill: "#FDDF6D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.08228 59.2245L5.21802 56.4393L7.38251 56.7488V53.306C7.38251 53.2673 2.78295 57.0196 1.08228 59.2245Z",
    fill: "#FDDF6D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.88 109.783L184.446 107.191L187.616 103.014L186.765 108.081L183.982 109.783H178.88Z",
    fill: "#FDDF6D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.616 103.014L183.248 106.457L174.358 109.783H178.88L184.446 107.191L187.616 103.014Z",
    fill: "#FDDF6D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.614 102.395L50.7884 104.329L53.1848 107.462L52.5664 103.671L50.4405 102.395H46.614Z",
    fill: "#FDDF6D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1848 107.462L49.8994 104.909L43.2126 102.395H46.614L50.7884 104.329L53.1848 107.462Z",
    fill: "#FDDF6D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.575 7.38814L174.397 6.0729L176.02 3.94531L175.595 6.49842L174.165 7.38814H171.575Z",
    fill: "#FDDF6D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.02 3.94531L173.817 5.68607L169.295 7.38814H171.575L174.397 6.0729L176.02 3.94531Z",
    fill: "#FDDF6D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38249 74.1949C5.02473 66.2261 2.55102 58.2572 0 50.3271V53.9248C2.58967 61.9709 5.02473 70.0558 7.38249 78.1406V74.1949Z",
    fill: "#FDDF6D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.653 24.1381C218.576 23.6739 218.498 23.2484 218.382 22.7842C216.373 24.9891 214.169 27.1167 211.734 29.2056C211.734 29.2443 211.734 29.283 211.734 29.3217V30.6756C214.247 28.548 216.566 26.3817 218.653 24.1381Z",
    fill: "#FDDF6D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.973 102.395C181.934 102.859 181.857 103.362 181.818 103.826C181.625 105.799 181.431 107.81 181.161 109.783H182.282C182.514 107.849 182.746 105.915 182.9 103.942C182.939 103.439 183.016 102.936 183.055 102.395H181.973Z",
    fill: "#FDDF6D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.054 7.38853C174.822 4.91279 174.397 2.43705 173.856 0H172.735C173.315 2.43705 173.701 4.87411 173.933 7.38853H175.054Z",
    fill: "#FDDF6D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9947 102.395H36.8738C37.4922 104.986 38.3039 107.501 39.1542 109.783H40.3524C39.4248 107.501 38.6131 105.025 37.9947 102.395Z",
    fill: "#FDDF6D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7776 7.38853H41.9371C41.0095 4.87411 39.8886 2.39837 38.6131 0H37.3762C38.6904 2.35969 39.8113 4.83543 40.7776 7.38853Z",
    fill: "#FDDF6D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.078 76.7861C217.262 75.5095 215.329 74.4651 213.396 73.6527C212.817 73.4206 212.276 73.1885 211.696 72.9951V74.1943C214.285 75.1227 216.759 76.5153 219.078 78.1787V76.7861Z",
    fill: "#FDDF6D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1367 104.252C12.9484 101.273 12.987 97.9851 12.5619 94.697C12.0594 94.1168 11.5956 93.4978 11.1704 92.8789C11.7888 96.5151 11.9821 100.229 11.1704 103.556C11.5183 103.788 11.8275 104.02 12.1367 104.252Z",
    fill: "#FDDF6D",
    fillOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 114,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedFrame);
export default __webpack_public_path__ + "static/media/RedFrame.bd0ed1bdd7574f688da90dc794a5c000.svg";
export { ForwardRef as ReactComponent };